import merge from "lodash/merge"

export function isBrowser() {
  return typeof window !== "undefined"
}

export function mergeProductData(product, variants) {
  const variantParent = variants.find(
    v => v.shopifyId === product.shopifyProduct
  ).product
  if (variantParent) {
    delete variantParent.shopfiyProduct
    return merge(variantParent, product)
  } else {
    return null
  }
}

export function formatPrice(currencyCode, price, minimumFractionDigits = 2) {
  return Intl.NumberFormat(undefined, {
    currency: currencyCode,
    minimumFractionDigits,
    style: "currency",
  }).format(price)
}

export function zeroPad(num, places = 3) {
  return String(num).padStart(places, "0")
}


export function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}



export function getSlug(string) {


  const isUrl = validURL(string)

  if (isUrl) {

    const url = new URL(`http://${string}`)
    const searchParams = url.searchParams
    return searchParams

  } else {
    return string
  }

}


export function slugify(string) {
  if (string&&typeof string =='string'){
  return string
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");

  }
}


export function convertToSlug(Text)
{
    return Text
        .toLowerCase()
        .replace(/ /g,'-')
        .replace(/[^\w-]+/g,'')
        ;
}


